export const PrimaryId = ['book', 'check_in', 'my_trips', 'flightstatus'];

export const PrimaryIdWithoutBook = ['check_in', 'my_trips', 'flightstatus'];

export const SecondaryId = ['secondarynav', 'sky-miles', 'more'];

export const MODIFY_BUTTON = 'Modify';

export const TRIP_TYPES = {
  MULTICITY: 'MULTICITY',
  ROUND_TRIP: 'ROUND_TRIP',
  ONE_WAY: 'ONE_WAY'
};
